import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';

import { BillingSchema, PlatformBillingSchema } from '../types/order-form.types';

import type { BillingSchemaType } from '../types/order-form.types';

export function useBillingForm() {
  // Default 'platform' — la mayoría de pedidos externos se facturan por plataforma. En modo
  // edición el hook de preload sobrescribe el valor según el pedido cargado.
  const [billingMethod, setBillingMethod] = useState<'email' | 'platform'>('platform');
  const [formMode, setFormMode] = useState<'email' | 'platform'>('platform');

  const resolver =
    formMode === 'email'
      ? zodResolver(BillingSchema)
      : (zodResolver(PlatformBillingSchema) as any);

  const billingMethods = useForm<BillingSchemaType>({
    resolver,
    defaultValues: {
      customerId: undefined,
      firstName: '',
      lastName: '',
      company: '',
      email: '',
      phone: '',
      nif: '',
      country: '',
      city: '',
      postalCode: '',
      address: '',
      platformId: undefined,
    },
  });

  const validateBillingForm = async () => {
    if (formMode === 'email') {
      return billingMethods.trigger();
    }
    return billingMethods.trigger('platformId');
  };

  // Sync resolver with billing method
  useEffect(() => {
    setFormMode(billingMethod);

    if (billingMethod === 'platform') {
      const platformId = billingMethods.getValues('platformId');
      billingMethods.reset({ platformId }, { keepErrors: false });
    } else {
      billingMethods.reset(
        {
          customerId: undefined,
          firstName: '',
          lastName: '',
          company: '',
          email: '',
          phone: '',
          nif: '',
          country: '',
          city: '',
          postalCode: '',
          address: '',
          platformId: undefined,
        },
        { keepErrors: false }
      );
    }
  }, [billingMethod, billingMethods]);

  return {
    billingMethod,
    setBillingMethod,
    billingMethods,
    validateBillingForm,
  };
}
